// src/services/invitationService.js

import axios from "axios";
import { API_URL } from "../config/apiConfig";

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});


export async function createInvitation(orgId, email, role) {
  const res = await api.post("/api/invitations", { orgId, email, role });
  return res.data;
}

export async function getInvitationInfo(token) {
  const res = await api.get(`/api/invitations/${token}`);
  return res.data;
}

export async function acceptInvitation(token) {
  const res = await api.post(`/api/invitations/accept/${token}`);
  return res.data;
}

export async function cancelInvitation(invitationId) {
  const res = await api.patch(`/api/invitations/cancel/${invitationId}`);
  return res.data;
}

export async function getInvitationsForOrg(orgId) {
    const res = await api.get(`/api/invitations/org/${orgId}`);
    return res.data;
  }